module.exports = __webpack_public_path__ + "img/u684.3c1024d6.png";